import styled from 'styled-components';
import { border, compose, opacity } from 'styled-system';
import Box from './Box';
export const Card = styled(Box).withConfig({
  displayName: "Card",
  componentId: "sc-nzi2uk-0"
})(compose(border, opacity));
Card.displayName = 'Card';
export default Card;